class Modal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.selectors = {
      close: '.modal__close',
    };

    this.setupEventListeners();
  }

  setupEventListeners() {
    document.addEventListener('click', event => {
      if (event.target.closest(`[href="#${this.getAttribute('data-target')}"]`)) {
        event.preventDefault();
        this.setAttribute('style', 'display: flex;');
      }
    });

    this.addEventListener('click', event => {
      if (event.target.closest(this.selectors.close)) {
        event.preventDefault();
        this.removeAttribute('style');
      }
    });
  }
}

customElements.define('custom-modal', Modal);
